import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="removeable"
export default class extends Controller {
  static values = {
    showDelay: { type: Number, default: 200 },
    removeDelay: { type: Number, default: 5000 },
    closeDelay: { type: Number, default: 220 },
    dismissAfter: { type: Boolean, default: true }
  }
  static classes = [
    "show", 
    "hide"
  ]

  initialize() {
    this.closing = false
    this.showTimeout = null
    this.dismissTimeout = null
    this.closeTimeout = null
    this.hide()
  }

  connect() {
    // Auto show (default hidden)
    this.showTimeout = setTimeout(() => {
      this.show();
      // Auto dismiss if defined
      if (this.dismissAfterValue) {
        this.dismissTimeout = setTimeout(() => {
          this.close();
        }, this.removeDelayValue);
      }
    }, this.showDelayValue);
  }

  disconnect() {
    clearTimeout(this.showTimeout)
    clearTimeout(this.dismissTimeout)
    clearTimeout(this.closeTimeout)
  }

  close() {
    if (this.closing) return
    this.closing = true

    clearTimeout(this.dismissTimeout)
    this.hide()

    this.closeTimeout = setTimeout(() => {
      const parent = this.element.parentElement
      this.element.remove()
      // Clean up empty flash wrapper divs that block pointer events
      if (parent && parent.children.length === 0 && parent.closest('#flash')) {
        parent.remove()
      }
    }, this.closeDelayValue)
  }

  show() {
    this.element.classList.add(...this.showClasses)
    this.element.classList.remove(...this.hideClasses)
  }

  hide() {
    this.element.classList.add(...this.hideClasses)
    this.element.classList.remove(...this.showClasses)
  }
}
